import { hasEmittedHeight, HEIGHT_LOWER_BOUND } from './initializeProviders';
/**
 * Returns which zone this provider is assigned to, or the empty string if it's not a zoned
 * provider. Accomplishes this by looking this provider up in the list of zoned providers.
 * This turn out to be slightly brittle; in some cases we use a mix of zoned and non-zoned
 * providers. In those cases, if the provider shows up in the zonedMetadata map we don't want
 * to list a zone for it if it isn't actually loaded in a zone on the page.
 *  * Relies on the assumption that providers can only show up once in a single page.
 * @param providerEl the HTML element of the provider on the page.
 * @param providerId the string identifier of the provider
 */
export const getZone = (providerEl, providerId) => {
    // First find the element on the page and check its parent to see if it's in a zone
    if (!providerEl ||
        !providerEl.parentElement ||
        !providerEl.parentElement.className ||
        providerEl.parentElement.className.indexOf('mosaic-zone') < 0) {
        return null;
    }
    // Now that we know it's zoned, get the actual zone
    const zones = window.mosaic.zonedProviders;
    for (const zone in zones) {
        if (zones[zone].indexOf(providerId) >= 0) {
            return zone;
        }
    }
    // Unzoned
    return null;
};
/**
 * We want to be able to log which position this provider is in its zone. The challenge is that
 * not every provider in the zone actually has content to show. Disabled or erroring content
 * providers still get put in the list (see MOSPLAT-806). This function filters them out by
 * cross-checking the providers in the zone with the overall list of providers. (Disabled or
 * erroring content providers won't show up in the overall list of providers because they don't
 * have associated JS bundles).
 * @param id The id of this provider
 * @param zone The zone this provider shows up in; see getZone()
 */
export const getIndexInZone = (id, zone) => {
    if (!zone) {
        return -1;
    }
    const providers = window.mosaic.providers;
    const zonedProviders = window.mosaic.zonedProviders[zone];
    let index = 0;
    for (const provider of zonedProviders) {
        // This is us.
        if (provider === id) {
            return index;
            // Only increment the count if it's registered in providers.
            // Otherwise it's not a real impression and won't show any content.
        }
        else if (providers[provider]) {
            index += 1;
        }
    }
    return -1;
};
/**
 * Identify whether a provider is registered as Lazy
 * @param id
 */
export const isLazy = (id) => window.mosaic && window.mosaic.lazyProviders && window.mosaic.lazyProviders.hasOwnProperty(id);
export const visibility = (id, register, dimensions) => {
    var _a, _b;
    const element = document.getElementById(id);
    const hasHtml = !!(element && element.innerHTML.length > 0);
    const height = element ? (_a = dimensions === null || dimensions === void 0 ? void 0 : dimensions.height) !== null && _a !== void 0 ? _a : element.clientHeight : 0;
    const width = element ? (_b = dimensions === null || dimensions === void 0 ? void 0 : dimensions.width) !== null && _b !== void 0 ? _b : element.clientWidth : 0;
    const hasHeight = height > 0;
    if (register && hasEmittedHeight[id] !== true) {
        const emittedHeight = height > HEIGHT_LOWER_BOUND;
        hasEmittedHeight[id] = emittedHeight;
    }
    return { hasHeight, hasHtml, width, height };
};
export const getPlatformData = (mosaicGlobal) => {
    return {
        host: mosaicGlobal.initialData.hostId,
        pageId: mosaicGlobal.initialData.pageId
    };
};
// This is currently just used for logging
export const getLoadMethod = (mosaicGlobal, id) => (mosaicGlobal.providerLoadMethod &&
    mosaicGlobal.providerLoadMethod.hasOwnProperty(id) &&
    mosaicGlobal.providerLoadMethod[id]) ||
    'immediate';
